import Config from '@skin_config';
import { changeSecondScreen } from '@common/helpers/secondScreen';

class LotoHandler {
  nestedLoad = Promise.withResolvers();

  openStream(visualLink) {
    changeSecondScreen(Config, { command: 'ThirdParty', id: 111, url: visualLink, providerId: 21 });
  }

  openDefault() {
    changeSecondScreen(Config, { command: 'Default', id: 0, url: '', providerId: 0 });
  }

  async onActionNeeded(iframe) {
    await this.nestedLoad.promise;
    const searchParams = new URLSearchParams(window.location.search);
    const action = searchParams.get('action');
    if (action === 'copyTicket') {
      const betId = searchParams.get('betId');

      if (betId) {
        setTimeout(() => (
          iframe.contentWindow.postMessage({ type: 'copyTicket', data: { id: betId } }, '*')
        ), 200);
      }
    }
  }

  onIframeMessage({ data }) {
    if (typeof data !== 'object') return;

    if (data.type === 'no-stream') {
      this.nestedLoad.resolve(true);
      this.openDefault();
    }

    if ('visualLink' in data) {
      this.nestedLoad.resolve(true);
      this.openStream(data.visualLink);
    }
  }
}

export default LotoHandler;
